<template>
  <section class="department-document health-survey">
    <header class="document-header">
      <h1>Basic Health Survey</h1>
      <h2>基本健康问卷</h2>
      <p class="required-note"><strong>*</strong> Gender is required; items 1–13 are required unless No. 14 is checked<br />性别始终必填；勾选第14项时，第1～13项可不选择</p>
    </header>

    <el-form label-position="top" class="document-form">
      <div class="section-title">Personal Information <span>个人信息</span></div>
      <div class="form-grid form-grid-three">
        <el-form-item label="Chinese Name 学生姓名">
          <el-input v-model="form.student_name" :disabled="locked('student_name')" />
        </el-form-item>
        <el-form-item label="Gender 性别 *">
          <el-radio-group v-model="form.gender" :disabled="locked('gender')" aria-required="true">
            <el-radio label="Male 男">Male 男</el-radio>
            <el-radio label="Female 女">Female 女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Year of Birth 出生年份">
          <el-date-picker
            v-model="form.birth_year"
            type="year"
            value-format="yyyy"
            placeholder="YYYY"
            :disabled="locked('birth_year')"
          />
        </el-form-item>
      </div>

      <div class="survey-note">
        If you have any corresponding conditions, please select the answer. If
        you have no health problems, please tick No. 14.<br />
        如果你有任何以下情况，请对应选择；如果没有任何健康问题，请勾选第 14 项。
      </div>

      <div
        v-for="item in standardItems.slice(0, 4)"
        :key="item.number"
        class="question-card"
      >
        <div class="question-heading">
          <span class="question-number">{{ item.number }}</span>
          <strong>{{ item.en }}</strong>
          <span>{{ item.zh }}</span>
          <span class="required-mark">*</span>
        </div>
        <el-radio-group v-model="form[item.field]" :disabled="locked(item.field)" aria-required="true">
          <el-radio label="yes">YES 是</el-radio>
          <el-radio label="no">NO 否</el-radio>
        </el-radio-group>
        <el-input
          v-model="form[item.detailField]"
          :disabled="locked(item.detailField)"
          placeholder="Please state 请注明"
          class="detail-input"
        />
        <div v-if="item.contagiousField && form[item.field] === 'yes'" class="inline-question">
          <span>Is it contagious? 是否传染 <span class="required-mark">*</span></span>
          <el-radio-group
            v-model="form[item.contagiousField]"
            :disabled="locked(item.contagiousField)"
            aria-required="true"
          >
            <el-radio label="yes">YES 是</el-radio>
            <el-radio label="no">NO 否</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="question-card">
        <div class="question-heading">
          <span class="question-number">5</span>
          <strong>Do you have allergies?</strong><span>你有任何过敏史吗？</span>
          <span class="required-mark">*</span>
        </div>
        <el-radio-group v-model="form.allergies_status" :disabled="locked('allergies_status')" aria-required="true">
          <el-radio label="yes">YES 是</el-radio>
          <el-radio label="no">NO 否</el-radio>
        </el-radio-group>
        <template v-if="form.allergies_status === 'yes'">
          <el-checkbox-group v-model="form.allergy_types" :disabled="locked('allergy_types')" class="detail-input">
            <el-checkbox label="Food 食物" />
            <el-checkbox label="Animals 动物" />
            <el-checkbox label="Dust 粉尘" />
            <el-checkbox label="Medicines 药物" />
          </el-checkbox-group>
          <el-input
            v-model="form.allergy_other"
            :disabled="locked('allergy_other')"
            placeholder="Others please state 其它请注明"
            class="detail-input"
          />
        </template>
      </div>

      <div class="question-card">
        <div class="question-heading">
          <span class="question-number">6</span>
          <strong>Internal organ problems</strong><span>内脏器官问题</span>
          <span class="required-mark">*</span>
        </div>
        <el-radio-group v-model="form.organ_problem" :disabled="locked('organ_problem')" aria-required="true">
          <el-radio label="yes">YES 是</el-radio>
          <el-radio label="no">NO 否</el-radio>
        </el-radio-group>
        <template v-if="form.organ_problem === 'yes'">
          <el-checkbox-group v-model="form.organ_types" :disabled="locked('organ_types')" class="detail-input">
            <el-checkbox label="Chest pain 胸痛" />
            <el-checkbox label="Heart problems 心脏问题" />
          </el-checkbox-group>
          <el-input
            v-model="form.organ_other"
            :disabled="locked('organ_other')"
            placeholder="Others please state 其它请注明"
            class="detail-input"
          />
        </template>
      </div>

      <div
        v-for="item in standardItems.slice(4)"
        :key="item.number"
        class="question-card"
      >
        <div class="question-heading">
          <span class="question-number">{{ item.number }}</span>
          <strong>{{ item.en }}</strong>
          <span>{{ item.zh }}</span>
          <span class="required-mark">*</span>
        </div>
        <el-radio-group v-model="form[item.field]" :disabled="locked(item.field)" aria-required="true">
          <el-radio label="yes">YES 是</el-radio>
          <el-radio label="no">NO 否</el-radio>
        </el-radio-group>
        <el-input
          v-model="form[item.detailField]"
          :disabled="locked(item.detailField)"
          placeholder="Please state 请注明"
          class="detail-input"
        />
        <div v-if="item.contagiousField && form[item.field] === 'yes'" class="inline-question">
          <span>Is it contagious? 是否传染 <span class="required-mark">*</span></span>
          <el-radio-group
            v-model="form[item.contagiousField]"
            :disabled="locked(item.contagiousField)"
            aria-required="true"
          >
            <el-radio label="yes">YES 是</el-radio>
            <el-radio label="no">NO 否</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="question-card no-illness-card">
        <div class="question-heading">
          <span class="question-number">14</span>
          <strong>No physical illness</strong><span>没有任何身体疾病</span>
          <span class="conditional-mark">无任何疾病时必填</span>
        </div>
        <el-checkbox v-model="form.no_physical_illness" :disabled="locked('no_physical_illness')">
          YES 是
        </el-checkbox>
      </div>

      <div class="declaration">
        <p>
          I (Student name)
          <el-input v-model="form.declaration_student_name" :disabled="locked('declaration_student_name')" />
          and the student's parents (Parents' names)
          <el-input v-model="form.parent_names" :disabled="locked('parent_names')" />
          promise that I do not have any infectious diseases or major physical
          illnesses. I acknowledge that if any dishonest information is
          provided in this survey, we will bear all consequences and the
          corresponding mental and financial compensation.
        </p>
        <p>
          本人（学生名字）及学生家长（家长名字）承诺没有任何传染病或重大身体疾病。如有与事实不符或有隐瞒，愿承担产生的一切后果及相应的精神和经济赔偿。
        </p>
      </div>

      <div class="signature-grid">
        <div class="signature-block">
          <label>Parent Signature 家长签名</label>
          <img v-if="readonly && form.parent_signature" :src="form.parent_signature" class="signature-image" />
          <template v-else-if="!readonly">
            <vue-esign ref="parentSignature" class="signature-pad" :line-width="2" line-color="#111827" />
            <el-button size="mini" @click="resetParentSignature">Reset 重签</el-button>
          </template>
          <el-input v-model="form.parent_print" :disabled="locked('parent_print')" placeholder="Parent Name (Print) 家长姓名（打印）" />
          <el-date-picker v-model="form.parent_date" :disabled="locked('parent_date')" type="date" value-format="yyyy-MM-dd" placeholder="Date 日期" />
        </div>
        <div class="signature-block">
          <label>Student Signature 学生签名</label>
          <img v-if="readonly && form.student_signature" :src="form.student_signature" class="signature-image" />
          <template v-else-if="!readonly">
            <vue-esign ref="studentSignature" class="signature-pad" :line-width="2" line-color="#111827" />
            <el-button size="mini" @click="resetStudentSignature">Reset 重签</el-button>
          </template>
          <el-input v-model="form.student_print" :disabled="locked('student_print')" placeholder="Student Name (Print) 学生姓名（打印）" />
          <el-date-picker v-model="form.student_date" :disabled="locked('student_date')" type="date" value-format="yyyy-MM-dd" placeholder="Date 日期" />
        </div>
      </div>
    </el-form>
  </section>
</template>

<script>
export default {
  name: "BasicHealthSurvey",
  props: {
    form: { type: Object, required: true },
    disabledFields: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      standardItems: [
        { number: 1, en: "Skin problems", zh: "皮肤问题", field: "skin_problem", detailField: "skin_details", contagiousField: "skin_contagious" },
        { number: 2, en: "Body aches and pain", zh: "肌肉酸痛", field: "body_aches", detailField: "body_aches_details" },
        { number: 3, en: "Diarrhea and/or vomiting", zh: "腹泻和/或呕吐", field: "diarrhea_vomiting", detailField: "diarrhea_vomiting_details" },
        { number: 4, en: "Eye problems", zh: "眼疾", field: "eye_problems", detailField: "eye_details" },
        { number: 7, en: "Problems breathing or coughing", zh: "呼吸或咳嗽问题", field: "breathing_problem", detailField: "breathing_details" },
        { number: 8, en: "Blood problems", zh: "血液问题", field: "blood_problem", detailField: "blood_details", contagiousField: "blood_contagious" },
        { number: 9, en: "Fainting or blacking out", zh: "昏厥", field: "fainting", detailField: "fainting_details" },
        { number: 10, en: "Injuries", zh: "伤痛/跌伤", field: "injuries", detailField: "injuries_details" },
        { number: 11, en: "Mental illness", zh: "心理或者精神疾病", field: "mental_illness", detailField: "mental_illness_details" },
        { number: 12, en: "Any daily medicines?", zh: "日常是否需要按时吃药？", field: "daily_medicines", detailField: "daily_medicines_details" },
        { number: 13, en: "Other problems", zh: "其它（包含但不限于以上问题）", field: "other_problem", detailField: "other_problem_details" },
      ],
    };
  },
  methods: {
    locked(field) {
      return this.readonly || Boolean(this.disabledFields && this.disabledFields[field]);
    },
    async generateParentSignature() {
      if (!this.$refs.parentSignature) return "";
      try { return await this.$refs.parentSignature.generate(); } catch (error) { return ""; }
    },
    async generateStudentSignature() {
      if (!this.$refs.studentSignature) return "";
      try { return await this.$refs.studentSignature.generate(); } catch (error) { return ""; }
    },
    resetParentSignature() {
      if (this.$refs.parentSignature) this.$refs.parentSignature.reset();
    },
    resetStudentSignature() {
      if (this.$refs.studentSignature) this.$refs.studentSignature.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.department-document { color: #172033; }
.document-header { margin-bottom: 32px; padding-top: 28px; text-align: center; }
.document-header h1 { margin: 4px 0; font-size: 30px; }
.document-header h2 { margin: 0; font-size: 21px; font-weight: 500; }
.required-note { margin: 10px 0 0; color: #64748b; font-size: 13px; }
.required-note strong, .required-mark { color: #e11d48; }
.conditional-mark { color: #b45309; font-size: 12px; font-weight: 500; }
.section-title { margin: 28px 0 18px; padding-bottom: 10px; border-bottom: 2px solid #dbe7f6; font-size: 18px; font-weight: 700; }
.section-title span { margin-left: 8px; color: #526174; font-weight: 500; }
.form-grid { display: grid; gap: 16px; }
.form-grid-three { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.survey-note { margin: 12px 0 20px; padding: 14px 18px; border-left: 4px solid #3b82f6; background: #eff6ff; line-height: 1.8; }
.question-card { margin: 12px 0; padding: 18px; border: 1px solid #e4eaf2; border-radius: 8px; break-inside: avoid; }
.question-heading { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-bottom: 14px; }
.question-number { display: inline-grid; width: 26px; height: 26px; place-items: center; border-radius: 50%; color: #fff; background: #315b8a; font-weight: 700; }
.detail-input { margin-top: 12px; }
.inline-question { display: flex; flex-wrap: wrap; gap: 18px; margin-top: 12px; }
.no-illness-card { border-color: #9bc5ad; background: #f1faf5; }
.declaration { margin: 28px 0; padding: 20px; border: 1px solid #cfd8e5; background: #f8fafc; line-height: 2; }
.declaration ::v-deep .el-input { display: inline-block; width: 220px; margin: 0 6px; }
.signature-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 28px; margin-top: 24px; }
.signature-block { display: grid; gap: 12px; }
.signature-block label { font-weight: 700; }
.signature-pad, .signature-image { width: 100% !important; height: 180px; border: 1px solid #cfd8e5; object-fit: contain; box-sizing: border-box; }
::v-deep .el-date-editor.el-input { width: 100%; }
@media (max-width: 767px) {
  .form-grid-three, .signature-grid { grid-template-columns: 1fr; }
  .document-header h1 { font-size: 24px; }
}
@media print {
  .question-card { box-shadow: none; }
}
</style>
